import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaDisciplinaNome = (): TabelaColuna => ({
  Chave: 'nomeDisciplina',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 200 }}>Nome Disciplina</div>
})
